<div class="container-fluid mt-5">
    <div class="row justify-content-center first-part">
        <div class="col-auto check-list-pic">
            <img [src]="taskListCheck2SvgPath" alt="Accounts Check List" />
        </div>
    </div>
    <div class="row mt-3 justify-content-center">
        <div class="col">
            <span class="aum-typo-headline-3 first-part-text">{{
                'aumico_core_empty_data_grid_assigned_all_accounts' | i18next
            }}</span>
        </div>
    </div>
</div>
